import type { InsightsAdapter } from "./types";

/**
 * Creates a mock insights adapter for testing.
 * In tests, use vi.fn() to create spy functions and replace these.
 *
 * Usage:
 *   const mockTag = vi.fn();
 *   const adapter = createInsightsAdapter(mockTag);
 *   adapter.trackPayment({ ... });
 *   expect(mockTag).toHaveBeenCalledWith({ name: 'PAYMENT', parameters: { ... } });
 *
 * Or for component tests with useInsightsAdapter:
 *   vi.mock('@/services/insights-adapter', () => ({
 *     useInsightsAdapter: () => createMockInsightsAdapter(),
 *   }));
 */
export function createMockInsightsAdapter(
  overrides?: Partial<InsightsAdapter>
): InsightsAdapter {
  const noop = () => {};
  return {
    trackPayment: noop,
    trackSelectConsultType: noop,
    trackConditionsWeTreat: noop,
    trackSelectPathologyType: noop,
    trackSelectCareCardType: noop,
    trackApplyCareCard: noop,
    ...overrides,
  };
}
